<template>
  <LoginLayout>
    <LayoutForm
        v-if="isShowForm"
        :enabledHeader="1 == step"
        :enabledFooter="1 === step"
        :enabledBodyHeader="1 === step"
        :enabledBodyHeaderDescription="1 === step"
      >
        <FormRegister
          v-if="1 === step"
          @submit="handleSubmit(2)"
        ></FormRegister>
        <RegisterDetail
          v-else-if="2 == step"
          @submit="handleSubmit(3)"
        ></RegisterDetail>
        <CreatedAccount v-else-if="3 === step"></CreatedAccount>
      </LayoutForm>
    <b-modal ref="my-modal" title="Message">
      <p v-text="message"></p>
    </b-modal>
  </LoginLayout>
</template>

<script>
import LoginLayout from "@/components/layouts/LoginNew.vue";
import LayoutForm from "@/components/layouts/FormLogin.vue";
import FormRegister from "@/components/forms/Register.vue";
import RegisterDetail from "@/components/forms/RegisterDetail.vue";
import CreatedAccount from "@/components/forms/CreatedAccount.vue";

import MixinLogin from "@/mixins/login";
import { mapActions, mapState } from "vuex";

const DEFAULT_STEP = 1;
export default {
  name: "page-register",
  components: {
    LoginLayout,
    LayoutForm,
    FormRegister,
    RegisterDetail,
    CreatedAccount
  },
  mixins: [MixinLogin],
  data() {
    return {
      message: "",
      step: DEFAULT_STEP
    };
  },
  computed: {
    ...mapState("siteBrand", ["brand"]),
    containerStyle() {
      return 1 === this.step ? null : { maxWidth: "570px" };
    }
  },
  methods: {
    ...mapActions("user", ["createUser"]),
    handleSubmit(step) {
      if (3 == step) {
        this.createUser()
          .then(resp => {
            const { result, errors } = resp;
            if (!result) {
              this.message = errors.join(",");
              this.$refs["my-modal"].show();
            } else {
              this.setStep(step);
            }
          })
          .catch(() => {});
        return;
      }
      this.setStep(step);
    },
    setStep(number) {
      this.step = number;
    },
    resetStep() {
      this.step = DEFAULT_STEP;
    }
  }
};
</script>

<style scoped lang="scss"></style>
